//LIBRARIES
import React, { useState } from 'react';
import styled from 'styled-components';
import { browserHistory } from 'react-router';

//COMPONENTS
import Spacer from 'components/ui/Spacer';
import Row from 'components/ui/Row';
import PillButton from 'components/ui/Buttons/PillButton';
import Col from 'components/ui/Col';
import BatchForm from '../BatchForm/BatchForm';
import { ButtonPrimary } from '@yuhu-inc/yuhui';
import ConfirmationDialog from 'components/shared/ConfirmationDialog';

//HELPER
import { getTranslatedString } from 'helpers/i18n';
import { colors } from 'helpers/ColorHelper';

const ScrollablePanel = styled.div`
  height: 100%;
`;

const FormTitle = styled.span`
  font-size: 20px;
  font-family: 'Circular-Bold';
`;

const StyledErrorButton = styled(PillButton)`
  color: ${colors.WHITE};
  background: ${colors.YUHU_RED};
`;

const FORM_NAME = 'edit_batch_form';

const BatchEditing = ({ selectedBatch, updateBatch, onUpdateBatch, deleteBatch }) => {
  const [confirmationDialogOpen, setDialogState] = useState(false);
  const batchInDraft = selectedBatch.status === 'draft';
  const batchContainsPayments = selectedBatch.payments_count !== 0;

  const handleUpdateBatch = async (values) => {
    try {
      const response = await updateBatch(values.id, values);
      // reload the batch details
      onUpdateBatch(response.batch);
    } catch (err) {
      console.error(err);
    }
  };

  const confirmDeleteBatch = async (id) => {
    if (batchInDraft && !batchContainsPayments) {
      try {
        await deleteBatch(id);
        toggleDialog();
        browserHistory.push('/companies/batches');
      } catch (err) {
        console.error(err);
      }
    }
  };

  const toggleDialog = () => {
    setDialogState(!confirmationDialogOpen);
  };

  return (
    <ScrollablePanel>
      <ConfirmationDialog
        showDialog={confirmationDialogOpen}
        hideDialog={toggleDialog}
        userConfirmVerbiage="Delete"
        userConfirmAction={() => confirmDeleteBatch(selectedBatch.id)}
        dialogTitle={getTranslatedString('landlordPortal.batches.confirmDeleteTitle')}
        dialogBodyVerbiage={getTranslatedString('landlordPortal.batches.confirmDeleteDescription')}
      />
      <Row>
        <Spacer style={{ width: '100%' }} pt={2} pb={2} pr={2} pl={2}>
          <FormTitle>{getTranslatedString('landlordPortal.batches.batchDetails')}</FormTitle>
          <BatchForm
            formName={FORM_NAME}
            formData={selectedBatch}
            onSubmissionComplete={handleUpdateBatch}
            handleSubmit={handleUpdateBatch}
            showBottomInfoText={false}
          />
          <Spacer mt={2}>
            <Row>
              <Col span={12}>
                <ButtonPrimary
                  form={FORM_NAME}
                  type="submit"
                  contentKey="landlordPortal.dashboard.saveChangeButton"
                />
              </Col>
              {batchInDraft && !batchContainsPayments && (
                <Col span={12}>
                  <StyledErrorButton
                    type="button"
                    shape="round"
                    onClick={() => toggleDialog()}
                    style={{ float: 'right' }}
                  >
                    {getTranslatedString('delete')}
                  </StyledErrorButton>
                </Col>
              )}
            </Row>
          </Spacer>
        </Spacer>
      </Row>
    </ScrollablePanel>
  );
};

export default BatchEditing;
